import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-e0d48f96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "interviewQuestionListHome" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"24px","font-weight":"bold"} }, "面试题目", -1))

import { ref } from "vue";
import API from "@/api";
import UserSider from "@/components/sider/UserSider.vue";

import InterviewQuestionTable from "@/components/list/InterviewQuestionTable.vue";
import InterviewQuestionBankPage from "@/views/interview/interviewQuestionBank/InterviewQuestionBankPage.vue";
import TagSelect from "@/components/selecter/TagSelecter.vue";
import MdEditor from "@/components/md/MdEditor.vue";
import { addInterviewQuestionUsingPost } from "@/request/api/interviewQuestionController";
import message from "@arco-design/web-vue/es/message";

//搜索参数

export default /*#__PURE__*/_defineComponent({
  __name: 'InterviewQuestionListPage',
  setup(__props) {

const searchParams = ref<API.InterviewQuestionQueryRequest>({
  current: 1,
  pageSize: 20,
  sortField: "createTime",
  sortOrder: "descend",
});

const addVisible = ref(false);
const addData = ref<API.InterviewQuestionAddRequest>({
  title: "",
  context: "",
  answer: "",
  tags: [],
  needVip: 0,
});
const addSubmit = async () => {
  const res = await addInterviewQuestionUsingPost(addData.value);
  if (res.data.code == 0) {
    addVisible.value = false;
    addData.value = {
      title: "",
      context: "",
      answer: "",
      tags: [],
      needVip: 0,
    };
    searchParams.value.current = 1;
    message.success("添加成功,请等待审核");
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_row, { justify: "center" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: "20" }, {
          default: _withCtx(() => [
            _createVNode(InterviewQuestionBankPage, { "page-size": 8 }),
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_a_space, null, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _createVNode(_component_a_button, {
                    type: "text",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (addVisible.value=true))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 添加题目 ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, {
                class: "interviewQuestionListHome",
                justify: "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: "17" }, {
                    default: _withCtx(() => [
                      _createVNode(InterviewQuestionTable, { "search-params": searchParams.value }, null, 8, ["search-params"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    span: "7",
                    style: {"margin-top":"62.5px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(UserSider, { "biz-type": "question" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: addVisible.value,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((addVisible).value = $event)),
      footer: false,
      draggable: "",
      width: "auto"
    }, {
      title: _withCtx(() => [
        _createTextVNode(" 添加题目")
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_a_form_item, { label: "标题" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                modelValue: addData.value.title,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((addData.value.title) = $event)),
                placeholder: "请输入标题...",
                "allow-clear": ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "内容" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_textarea, {
                modelValue: addData.value.context,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((addData.value.context) = $event)),
                placeholder: "请输入内容...",
                "allow-clear": ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "答案" }, {
            default: _withCtx(() => [
              _createVNode(MdEditor, {
                "md-text": addData.value.answer,
                "onUpdate:mdText": _cache[3] || (_cache[3] = ($event: any) => ((addData.value.answer) = $event)),
                onOnChange: _cache[4] || (_cache[4] = (text) => (addData.value.answer = text))
              }, null, 8, ["md-text"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "标签" }, {
            default: _withCtx(() => [
              _createVNode(TagSelect, {
                modelValue: addData.value.tags,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((addData.value.tags) = $event)),
                placeholder: "可选5个标签，可搜索",
                limit: 5
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: addSubmit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 添加")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})